import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import queryString from 'query-string';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import BookList from 'rebook/apps/books/components/BookList';
import Button from 'rebook/apps/base/components/Button';

import styles from './style.scss';


const PAGE_ITEMS_LIMIT = 12;
const STATUSES_MAPPER = {
  allBooks: 0,
  wishlist: 1,
  reading: 2,
  read: 3,
  uploads: 4,
  haveTimeToRead: 5,
};

class UserProfileViewBooks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      books: null,
      nextPage: null,
    };
    this.fetchBooks();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status != this.props.status || prevProps.type != this.props.type) {
      this.fetchBooks();
    }
  }

  sortBookListByDateAscending(bookList = []) {
    return bookList.sort((a, b) => {
      const nextItem = new Date(a.book.available_for_user_till);
      const currentItem = new Date(b.book.available_for_user_till);

      return currentItem - nextItem;
    });
  }

  fetchBooks(fetchNextPage = false) {
    const { userId, status, type } = this.props;
    const { nextPage } = this.state;
    let queryParams = {
      user: userId,
      order_by: '-changed_at',
      limit: PAGE_ITEMS_LIMIT,
      readinglist: status,
      type,
    };

    let apiUrl = '/api/bookuserlist/';

    if (status === STATUSES_MAPPER.haveTimeToRead) {
      queryParams.have_time_to_read = 1;
      queryParams.readinglist = '';
    }

    if (status === STATUSES_MAPPER.allBooks) {
      queryParams.readinglist = '';
    }

    if (status === STATUSES_MAPPER.uploads) {
      queryParams = {
        user: userId,
        limit: PAGE_ITEMS_LIMIT,
      };
      apiUrl = '/api/upload/';
    }

    const qs = queryString.stringify(queryParams);
    let url = fetchNextPage ? nextPage : `${apiUrl}?${qs}`;

    fetchQuery(url, { apiVersion: 6 })
      .then(
        ({ data }) => {
          let books = get(data, 'objects', []);
          if (status === STATUSES_MAPPER.haveTimeToRead) {
            books = this.sortBookListByDateAscending(books);
          }
          this.setState({
            books: fetchNextPage ? [...this.state.books, ...books] : books,
            nextPage: get(data, 'meta.next', null),
          });
        }
      );
  }

  handleBookClick(book) {
    if (get(book, 'available_for_user_only', false)) {
      const isAudio = book.type === 'audio';
      ga('send', 'event', {
        eventCategory: 'MyBooks',
        eventAction: 'OpenExpireSoonBook',
        eventLabel: isAudio ? 'Audio' : 'Books',
      });
    }
  }

  render() {
    const { books, nextPage } = this.state;
    return (
      <div className="section">

        {get(books, 'length', 0) === 0
          ? <BookList books={[...Array(5)]} />
          : <BookList books={books} shouldShowAvailable linkCallback={this.handleBookClick} />
        }
        {nextPage && (
          <Button
            extraClassName={styles.more}
            handleClick={() => this.fetchBooks(true)}
            theme="secondary">
            Загрузить ещё
          </Button>
        )}
      </div>
    );
  }
}

UserProfileViewBooks.propTypes = {
  userId: PropTypes.number,
  status: PropTypes.number,
  type: PropTypes.oneOf(['text', 'audio']),
};

UserProfileViewBooks.defaultProps = {
  userId: 0,
  status: 1,
  type: 'text',
};

export default UserProfileViewBooks;
